import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAHFHXZfLRt0tAr1JBIbfFVWJYYdmwssvs",
    authDomain: "streempay.firebaseapp.com",
    databaseURL: "https://streempay.firebaseio.com",
    projectId: "streempay",
    storageBucket: "streempay.appspot.com",
    messagingSenderId: "508726390649",
    appId: "1:508726390649:web:16b3f75ddc4a0b41e5c9a8"
};

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

if (window.location.hostname === "localhost") {
    console.log('using firebase emulator...');
    //db.useEmulator("localhost", 8080);
}

export const auth = (token) => {
    return firebase.auth().signInWithCustomToken(token);
}

export const getUserTracking = (userId) => {
    console.log('** FIREBASE ** getting user tracking data');
    return db.collection('users')
                .where('data.user_id', '==', userId)
                .orderBy('data.timestamp').get();
};

